module.exports = __webpack_public_path__ + "pm.svg?c993eb402d01bb857b38359a74624986";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/pm.svg
// module id = 1355
// module chunks = 27